import { render, staticRenderFns } from "./PromotionRowCTA.vue?vue&type=template&id=cf8287be&scoped=true"
import script from "./PromotionRowCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionRowCTA.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotionRowCTA.vue?vue&type=style&index=0&id=cf8287be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8287be",
  null
  
)

export default component.exports